<template>
  <div class="w-100">
    <Jumbotron :item="style" type="styles" :name="$t('main.groupers.styles.title')" />
    <b-container fluid>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="position-absolute w-100">
            <Loading />
          </div>
          <GridCSS v-else :items="styleContent" :send-vector-click="true">
            <template #default="slotProps">
              <NormalVectorOverlay :data="slotProps.data" />
            </template>
          </GridCSS>
          <GrouperPaginator
            name-page="style"
            :total-pages="styleTotalPages"
            :current-page="styleCurrentPage"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import GridCSS from '@/components/Common/GridCSS';
import GrouperPaginator from '@/components/Groupers/GrouperPaginator';
import Jumbotron from '@/components/Common/Jumbotron';
import Loading from 'UI/Loading';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';

export default {
  nuxtI18n: {
    paths: {
      en: '/styles/:slug',
      de: '/stilarten/:slug',
      es: '/estilos/:slug',
      pt: '/estilo/:slug'
    }
  },
  components: {
    GridCSS,
    GrouperPaginator,
    Jumbotron,
    Loading,
    NormalVectorOverlay
  },
  async validate({ params, store }) {
    const currentPage = params.page ? parseInt(params.page) : 1;

    store.dispatch('styles/CLEAN_STYLES');
    await Promise.all([
      store.dispatch('styles/LOAD_STYLE', { slug: params.slug }),
      store.dispatch('styles/LOAD_STYLE_CONTENT', {
        slug: params.slug,
        page: currentPage
      })
    ]);
    return store.state.styles.styleContent.length;
  },
  async fetch({ store }) {
    const { en, de, es, pt } = store.state.styles.style.metadata;
    const slugs = {
      en: { slug: en },
      de: { slug: de },
      es: { slug: es },
      pt: { slug: pt }
    };
    store.dispatch('i18n/setRouteParams', slugs);
  },
  head() {
    const metadata = this.$store.state.styles.style.metadata;
    const i18nSeo = this.$seoPlugin({ slash: true, canonicalLink: metadata?.cannonical });
    const openGraph = this.$openGraphPlugin(
      metadata?.metaTitle,
      'website',
      this.$route.path,
      metadata?.metaDescription,
      this.getImageFirstResult,
      this.$store.state.i18n.locale
    );
    return {
      title: metadata?.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: metadata?.metaDescription
        },
        ...openGraph
      ],
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapState('styles', [
      'style',
      'styleContent',
      'styleTotalPages',
      'styleCurrentPage',
      'isLoading'
    ]),
    ...mapGetters('styles', ['getImageFirstResult'])
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 27px;
}
p {
  font-size: 16px;
}
.badge-secondary {
  background: #b8aea4;
}
</style>
